
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
h1, h2, h3, h4, h5, h6 {
  margin:0px;
}

:host([site='BH']) h1, :host([site='BH']) h2, :host([site='BH']) h3, :host([site='BH']) h5, :host([site='BH']) h6 {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) h1, :host([site='BH']) h2, :host([site='BH']) h3 {
  font-weight:var(--fw-light);
}

:host([site='BH']) h5, :host([site='BH']) h6 {
  font-weight:var(--fw-bold);
}

:host([site='BH']) h1 {
  font-size:var(--bh-fs-heading-07);
  line-height:var(--bh-lh-heading-07);
  letter-spacing:var(--bh-ls-heading-07);
}

:host([site='BH']) h2 {
  font-size:var(--bh-fs-heading-06);
  line-height:var(--bh-lh-heading-06);
  letter-spacing:var(--bh-ls-heading-06);
}

:host([site='BH']) h3 {
  font-size:var(--bh-fs-heading-05);
  line-height:var(--bh-lh-heading-05);
  letter-spacing:var(--bh-ls-heading-05);
}

:host([site='BH']) h4 {
  font-family:var(--bh-ff-display);
}

:host([site='BH']) h4 {
  font-size:var(--bh-fs-heading-04);
  line-height:var(--bh-lh-heading-04);
  letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) h4 {
  font-weight:var(--fw-normal);
}

:host([site='BH']) h5 {
  font-size:var(--bh-fs-heading-03);
  line-height:var(--bh-lh-heading-03);
  letter-spacing:var(--bh-ls-heading-03);
}

:host([site='BH']) h6 {
  font-size:var(--bh-fs-heading-02);
  line-height:var(--bh-lh-heading-02);
  letter-spacing:var(--bh-ls-heading-02);
}

:host([site='BH']) h1.outline-font--h1, :host([site='BH']) h1.outline-font--h2, :host([site='BH']) h1.outline-font--h3, :host([site='BH']) h1.outline-font--h5, :host([site='BH']) h1.outline-font--h6, :host([site='BH']) h2.outline-font--h1, :host([site='BH']) h2.outline-font--h2, :host([site='BH']) h2.outline-font--h3, :host([site='BH']) h2.outline-font--h5, :host([site='BH']) h2.outline-font--h6, :host([site='BH']) h3.outline-font--h1, :host([site='BH']) h3.outline-font--h2, :host([site='BH']) h3.outline-font--h3, :host([site='BH']) h3.outline-font--h5, :host([site='BH']) h3.outline-font--h6, :host([site='BH']) h4.outline-font--h1, :host([site='BH']) h4.outline-font--h2, :host([site='BH']) h4.outline-font--h3, :host([site='BH']) h4.outline-font--h5, :host([site='BH']) h4.outline-font--h6, :host([site='BH']) h5.outline-font--h1, :host([site='BH']) h5.outline-font--h2, :host([site='BH']) h5.outline-font--h3, :host([site='BH']) h5.outline-font--h5, :host([site='BH']) h5.outline-font--h6, :host([site='BH']) h6.outline-font--h1, :host([site='BH']) h6.outline-font--h2, :host([site='BH']) h6.outline-font--h3, :host([site='BH']) h6.outline-font--h5, :host([site='BH']) h6.outline-font--h6 {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) h1.outline-font--h1, :host([site='BH']) h1.outline-font--h2, :host([site='BH']) h1.outline-font--h3, :host([site='BH']) h2.outline-font--h1, :host([site='BH']) h2.outline-font--h2, :host([site='BH']) h2.outline-font--h3, :host([site='BH']) h3.outline-font--h1, :host([site='BH']) h3.outline-font--h2, :host([site='BH']) h3.outline-font--h3, :host([site='BH']) h4.outline-font--h1, :host([site='BH']) h4.outline-font--h2, :host([site='BH']) h4.outline-font--h3, :host([site='BH']) h5.outline-font--h1, :host([site='BH']) h5.outline-font--h2, :host([site='BH']) h5.outline-font--h3, :host([site='BH']) h6.outline-font--h1, :host([site='BH']) h6.outline-font--h2, :host([site='BH']) h6.outline-font--h3 {
  font-weight:var(--fw-light);
}

:host([site='BH']) h1.outline-font--h5, :host([site='BH']) h1.outline-font--h6, :host([site='BH']) h2.outline-font--h5, :host([site='BH']) h2.outline-font--h6, :host([site='BH']) h3.outline-font--h5, :host([site='BH']) h3.outline-font--h6, :host([site='BH']) h4.outline-font--h5, :host([site='BH']) h4.outline-font--h6, :host([site='BH']) h5.outline-font--h5, :host([site='BH']) h5.outline-font--h6, :host([site='BH']) h6.outline-font--h5, :host([site='BH']) h6.outline-font--h6 {
  font-weight:var(--fw-bold);
}

:host([site='BH']) h1.outline-font--h1, :host([site='BH']) h2.outline-font--h1, :host([site='BH']) h3.outline-font--h1, :host([site='BH']) h4.outline-font--h1, :host([site='BH']) h5.outline-font--h1, :host([site='BH']) h6.outline-font--h1 {
  font-size:var(--bh-fs-heading-07);
  line-height:var(--bh-lh-heading-07);
  letter-spacing:var(--bh-ls-heading-07);
}

:host([site='BH']) h1.outline-font--h2, :host([site='BH']) h2.outline-font--h2, :host([site='BH']) h3.outline-font--h2, :host([site='BH']) h4.outline-font--h2, :host([site='BH']) h5.outline-font--h2, :host([site='BH']) h6.outline-font--h2 {
  font-size:var(--bh-fs-heading-06);
  line-height:var(--bh-lh-heading-06);
  letter-spacing:var(--bh-ls-heading-06);
}

:host([site='BH']) h1.outline-font--h3, :host([site='BH']) h2.outline-font--h3, :host([site='BH']) h3.outline-font--h3, :host([site='BH']) h4.outline-font--h3, :host([site='BH']) h5.outline-font--h3, :host([site='BH']) h6.outline-font--h3 {
  font-size:var(--bh-fs-heading-05);
  line-height:var(--bh-lh-heading-05);
  letter-spacing:var(--bh-ls-heading-05);
}

:host([site='BH']) h1.outline-font--h4, :host([site='BH']) h2.outline-font--h4, :host([site='BH']) h3.outline-font--h4, :host([site='BH']) h4.outline-font--h4, :host([site='BH']) h5.outline-font--h4, :host([site='BH']) h6.outline-font--h4 {
  font-family:var(--bh-ff-display);
}

:host([site='BH']) h1.outline-font--h4, :host([site='BH']) h2.outline-font--h4, :host([site='BH']) h3.outline-font--h4, :host([site='BH']) h4.outline-font--h4, :host([site='BH']) h5.outline-font--h4, :host([site='BH']) h6.outline-font--h4 {
  font-size:var(--bh-fs-heading-04);
  line-height:var(--bh-lh-heading-04);
  letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) h1.outline-font--h4, :host([site='BH']) h2.outline-font--h4, :host([site='BH']) h3.outline-font--h4, :host([site='BH']) h4.outline-font--h4, :host([site='BH']) h5.outline-font--h4, :host([site='BH']) h6.outline-font--h4 {
  font-weight:var(--fw-normal);
}

:host([site='BH']) h1.outline-font--h5, :host([site='BH']) h2.outline-font--h5, :host([site='BH']) h3.outline-font--h5, :host([site='BH']) h4.outline-font--h5, :host([site='BH']) h5.outline-font--h5, :host([site='BH']) h6.outline-font--h5 {
  font-size:var(--bh-fs-heading-03);
  line-height:var(--bh-lh-heading-03);
  letter-spacing:var(--bh-ls-heading-03);
}

:host([site='BH']) h1.outline-font--h6, :host([site='BH']) h2.outline-font--h6, :host([site='BH']) h3.outline-font--h6, :host([site='BH']) h4.outline-font--h6, :host([site='BH']) h5.outline-font--h6, :host([site='BH']) h6.outline-font--h6 {
  font-size:var(--bh-fs-heading-02);
  line-height:var(--bh-lh-heading-02);
  letter-spacing:var(--bh-ls-heading-02);
}

:host([site='GHS']) h1, :host([site='GHS']) h2, :host([site='GHS']) h3, :host([site='GHS']) h4, :host([site='GHS']) h5, :host([site='GHS']) h6 {
  font-family:var(--ff-display);
}

h2.h1, h3.h1, h4.h1, h5.h1, h6.h1, h1 {
  font-size:var(--fs-h1-small);
  line-height:var(--lh-h1-small);
}

@media (min-width: 768px) {

  h2.h1, h3.h1, h4.h1, h5.h1, h6.h1, h1 {
    font-size:var(--fs-h1-medium);
    line-height:var(--lh-h1-medium);
  }
}

@media (min-width: 1024px) {

  h2.h1, h3.h1, h4.h1, h5.h1, h6.h1, h1 {
    font-size:var(--fs-h1);
    line-height:var(--lh-h1);
  }
}

h1.h2, h3.h2, h4.h2, h5.h2, h6.h2, h2 {
  font-size:var(--fs-h2-small);
  line-height:var(--lh-h2-small);
}

@media (min-width: 768px) {

  h1.h2, h3.h2, h4.h2, h5.h2, h6.h2, h2 {
    font-size:var(--fs-h2-medium);
    line-height:var(--lh-h2-medium);
  }
}

@media (min-width: 1024px) {

  h1.h2, h3.h2, h4.h2, h5.h2, h6.h2, h2 {
    font-size:var(--fs-h2);
    line-height:var(--lh-h2);
  }
}

h1.h3, h2.h3, h4.h3, h5.h3, h6.h3, h3 {
  font-size:var(--fs-h3-small);
  line-height:var(--lh-h3-small);
}

@media (min-width: 768px) {

  h1.h3, h2.h3, h4.h3, h5.h3, h6.h3, h3 {
    font-size:var(--fs-h3-medium);
    line-height:var(--lh-h3-medium);
  }
}

@media (min-width: 1024px) {

  h1.h3, h2.h3, h4.h3, h5.h3, h6.h3, h3 {
    font-size:var(--fs-h3);
    line-height:var(--lh-h3);
  }
}

h1.h4, h2.h4, h3.h4, h5.h4, h6.h4, h4 {
  font-size:var(--fs-h4-small);
  line-height:var(--lh-h4-small);
}

@media (min-width: 768px) {

  h1.h4, h2.h4, h3.h4, h5.h4, h6.h4, h4 {
    font-size:var(--fs-h4-medium);
    line-height:var(--lh-h4-medium);
  }
}

@media (min-width: 1024px) {

  h1.h4, h2.h4, h3.h4, h5.h4, h6.h4, h4 {
    font-size:var(--fs-h4);
    line-height:var(--lh-h4);
  }
}

h1.h5, h2.h5, h3.h5, h4.h5, h6.h5, h5 {
  font-size:var(--fs-h5-small);
  line-height:var(--lh-h5-small);
}

@media (min-width: 768px) {

  h1.h5, h2.h5, h3.h5, h4.h5, h6.h5, h5 {
    font-size:var(--fs-h5-medium);
    line-height:var(--lh-h5-medium);
  }
}

@media (min-width: 1024px) {

  h1.h5, h2.h5, h3.h5, h4.h5, h6.h5, h5 {
    font-size:var(--fs-h5);
    line-height:var(--lh-h5);
  }
}

h1.h6, h2.h6, h3.h6, h4.h6, h5.h6, h6 {
  font-size:var(--fs-h6-small);
  line-height:var(--lh-h6-small);
}

@media (min-width: 768px) {

  h1.h6, h2.h6, h3.h6, h4.h6, h5.h6, h6 {
    font-size:var(--fs-h6-medium);
    line-height:var(--lh-h6-medium);
  }
}

@media (min-width: 1024px) {

  h1.h6, h2.h6, h3.h6, h4.h6, h5.h6, h6 {
    font-size:var(--fs-h6);
    line-height:var(--lh-h6);
  }
}

.outline-text--base {
  font-size:var(--fs-base) !important;
  line-height:var(--lh-base) !important;
}

.outline-text--xs {
  font-size:var(--fs-xs) !important;
  line-height:var(--lh-xs) !important;
}

.outline-text--sm {
  font-size:var(--fs-sm) !important;
  line-height:var(--lh-sm) !important;
}

.outline-text--lg {
  font-size:var(--fs-lg) !important;
  line-height:var(--lh-lg) !important;
}

.outline-text--lg.mobile {
  font-size:var(--fs-base) !important;
  line-height:var(--lh-base) !important;
}

.outline-text--xl {
  font-size:var(--fs-xl) !important;
  line-height:var(--lh-xl) !important;
}

.outline-text--xl.mobile {
  font-size:var(--fs-base) !important;
  line-height:var(--lh-base) !important;
}

.outline-text--2xl {
  font-size:var(--fs-2xl) !important;
  line-height:var(--lh-2xl) !important;
}

.outline-text--2xl.mobile {
  font-size:var(--fs-lg) !important;
  line-height:var(--lh-lg) !important;
}

.outline-text--3xl {
  font-size:var(--fs-3xl) !important;
  line-height:var(--lh-3xl) !important;
}

.outline-text--3xl.mobile {
  font-size:var(--fs-lg) !important;
  line-height:var(--lh-lg) !important;
}

.outline-text--4xl {
  font-size:var(--fs-4xl) !important;
  line-height:var(--lh-4xl) !important;
}

.outline-text--4xl.mobile {
  font-size:var(--fs-xl) !important;
  line-height:var(--lh-xl) !important;
}

.outline-text--5xl {
  font-size:var(--fs-5xl) !important;
  line-height:var(--lh-5xl) !important;
}

.outline-text--5xl.mobile {
  font-size:var(--fs-2xl) !important;
  line-height:var(--lh-2xl) !important;
}

.outline-text--6xl {
  font-size:var(--fs-6xl) !important;
  line-height:var(--lh-6xl) !important;
}

.outline-text--6xl.mobile {
  font-size:var(--fs-3xl) !important;
  line-height:var(--lh-3xl) !important;
}

.outline-text--7xl {
  font-size:var(--fs-7xl) !important;
  line-height:var(--lh-7xl) !important;
}

.outline-text--7xl.mobile {
  font-size:var(--fs-4xl) !important;
  line-height:var(--lh-4xl) !important;
}

.outline-text--8xl {
  font-size:var(--fs-8xl) !important;
  line-height:var(--lh-8xl) !important;
}

.outline-text--8xl.mobile {
  font-size:var(--fs-5xl) !important;
  line-height:var(--lh-5xl) !important;
}

.outline-text--9xl {
  font-size:var(--fs-9xl) !important;
  line-height:var(--lh-9lx) !important;
}

.outline-text--9xl.mobile {
  font-size:var(--fs-6xl) !important;
  line-height:var(--lh-6xl) !important;
}

.outline-font--thin {
  font-weight:var(--fw-extralight);
}

.outline-font--extralight {
  font-weight:var(--fw-thin);
}

.outline-font--light {
  font-weight:var(--fw-light);
}

.outline-font--normal {
  font-weight:var(--fw-normal);
}

.outline-font--semibold {
  font-weight:var(--fw-semibold);
}

.outline-font--bold {
  font-weight:var(--fw-bold);
}

.outline-font--extrabold {
  font-weight:var(--fw-extrabold);
}

.outline-font--black {
  font-weight:var(--fw-black);
}

.btn {
  display:flex;
  cursor:pointer;
  align-items:center;
  border-radius:10px;
  border-width:0px;
  font-weight:var(--fw-semibold);
  line-height:1.25;
  text-decoration-line:none;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
  min-width:44px;
}

.btn:focus{
    outline-width:1px;
    outline-style:dashed;
    outline-offset:4px;
  }

.btn:not(.cta-dark, .cta-light) {
  background-color:var(--bh-neutral-light);
}

.btn:not(.cta-dark, .cta-light) {
  color:var(--bh-neutral-white);
}

.btn:not(.cta-dark, .cta-light):hover, .btn:not(.cta-dark, .cta-light):focus {
  background-color:var(--bh-neutral-default);
}

.btn:not(.cta-dark, .cta-light):focus {
  outline-color:var(--bh-neutral-default);
}

.btn.parent-container-fit {
  display:flex;
  height:100%;
  width:100%;
  justify-content:center;
}

.btn.parent-container-fit .left, .btn.parent-container-fit .right {
  margin-bottom:0px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  padding-top:0px;
}

.btn.parent-container-fit.justify-between{
  justify-content:space-between;
}

.btn.border-bottom-radius {
  border-bottom-left-radius:0px;
  border-bottom-right-radius:0px;
}

.btn ghs-icon {
  position:relative;
  margin-left:0.5rem;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
}

.btn.chip {
  border-radius:0.375rem;
  border-width:1px;
  border-style:solid;
  font-weight:var(--fw-normal);
}

.btn.chip .right ghs-icon {
  margin-left:0px;
}

.btn.chip:focus {
  outline-style:solid;
}

.btn.chip:focus {
  outline-width:2px;
}

.btn.chip.small {
  height:30px;
}

.btn.chip.small {
  padding-left:0.375rem;
  padding-right:0.375rem;
}

.btn.chip.small {
  padding-top:0.25rem;
  padding-bottom:0.25rem;
}

.btn.chip.small .right {
  padding-left:0.5rem;
}

.btn.chip.medium {
  height:37px;
}

.btn.chip.medium {
  padding-left:0.5rem;
  padding-right:0.5rem;
}

.btn.chip.medium .right {
  padding-left:0.625rem;
}

.btn.chip.large {
  height:43px;
}

.btn.chip.large {
  padding-left:1rem;
  padding-right:1rem;
}

.btn.chip.large .right {
  padding-left:0.75rem;
}

.btn.none {
  display:flex;
  align-items:center;
  padding-left:1rem;
  padding-right:1rem;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.left {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
}

.top {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
  padding-bottom:0.5rem;
}

.right {
  display:flex;
  height:100%;
  align-items:center;
  padding-left:0.5rem;
}

.btn[aria-disabled='true'] {
  pointer-events:none !important;
  cursor:not-allowed !important;
  background-color:var(--neutral-gray-4) !important;
  color:var(--neutral-gray-1) !important;
}

.btn.small {
  max-height:45px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.medium {
  max-height:55px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.large {
  min-height:45px;
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

@media (min-width: 768px) {

  .btn.large {
    min-height:max-content;
  }

  .btn.large {
    padding-left:2rem;
    padding-right:2rem;
  }

  .btn.large {
    padding-top:1rem;
    padding-bottom:1rem;
  }

  .btn.large {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
  }
}

.btn.xl {
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  font-weight:var(--fw-light);
}

@media (min-width: 768px) {

  .btn.xl {
    min-height:max-content;
  }

  .btn.xl {
    padding-left:2rem;
    padding-right:2rem;
  }

  .btn.xl {
    padding-top:1rem;
    padding-bottom:1rem;
  }

  .btn.xl {
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
  }
}

.btn.cta-dark.small, .btn.cta-light.small, .btn.cta-dark.large, .btn.cta-light.large {
  padding:0px;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  min-height:auto;
}

.btn:has(> .top) {
  flex-direction:column;
  align-items:center;
  text-align:center;
}

[site='GHS'] .btn, :host([site='GHS']) .btn {
  font-family:var(--ff-display);
}

[site='GHS'] .btn.primary, [site='GHS'] .btn.secondary, [site='GHS'] .btn.tertiary, [site='GHS'] .btn.quaternary, :host([site='GHS']) .btn.primary, :host([site='GHS']) .btn.secondary, :host([site='GHS']) .btn.tertiary, :host([site='GHS']) .btn.quaternary {
  transition-property:box-shadow;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.tertiary:hover, [site='GHS'] .btn.quaternary:hover, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.tertiary:hover, :host([site='GHS']) .btn.quaternary:hover{
      box-shadow:var(--brand-shadow-sm);
    }

[site='GHS'] .btn.primary, :host([site='GHS']) .btn.primary {
  background-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.primary, :host([site='GHS']) .btn.primary {
  color:var(--neutral-white);
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.primary:focus {
  background-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.primary:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.secondary, :host([site='GHS']) .btn.secondary {
  background-color:var(--primary-green);
}

[site='GHS'] .btn.secondary, :host([site='GHS']) .btn.secondary {
  color:var(--neutral-white);
}

[site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.secondary:focus {
  background-color:var(--primary-green);
}

[site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.secondary:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:focus {
  outline-color:var(--primary-green);
}

[site='GHS'] .btn.tertiary, :host([site='GHS']) .btn.tertiary {
  background-color:var(--neutral-white);
}

[site='GHS'] .btn.tertiary, :host([site='GHS']) .btn.tertiary {
  color:var(--primary-blue);
}

[site='GHS'] .btn.tertiary:focus, :host([site='GHS']) .btn.tertiary:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  text-align:left;
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  text-decoration-line:underline;
}

[site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  text-align:left;
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  color:var(--neutral-white);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  text-decoration-line:underline;
}

[site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary, :host([site='GHS']) .btn.quaternary {
  background-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-white:focus, :host([site='GHS']) .btn.quaternary.border-white:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  color:var(--primary-blue);
}

[site='GHS'] .btn.quaternary.border-blue:focus, :host([site='GHS']) .btn.quaternary.border-blue:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-magenta:focus, :host([site='GHS']) .btn.quaternary.border-magenta:focus {
  outline-color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-color:var(--primary-green);
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  color:var(--primary-green);
}

[site='GHS'] .btn.quaternary.border-green:focus, :host([site='GHS']) .btn.quaternary.border-green:focus {
  outline-color:var(--primary-green);
}

[site='GHS'] .btn.tertiary.text-white, :host([site='GHS']) .btn.tertiary.text-white {
  color:var(--neutral-white);
}

[site='GHS'] .btn.tertiary.text-blue, :host([site='GHS']) .btn.tertiary.text-blue {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.tertiary.text-magenta, :host([site='GHS']) .btn.tertiary.text-magenta {
  color:var(--tertiary-magenta);
}

[site='GHS'] .btn.tertiary.text-green, :host([site='GHS']) .btn.tertiary.text-green {
  color:var(--primary-green);
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  min-height:6.5rem;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-radius:0px;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-width:2px;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-style:solid;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-color:var(--neutral-white);
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  background-color:var(--primary-blue);
}

@media (min-width: 768px) {

  [site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
    min-height:7.5rem;
  }
}

[site='GHS'] .btn.primary.border-square:hover, :host([site='GHS']) .btn.primary.border-square:hover {
  text-decoration-line:underline;
}

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, [site='BH'] .btn.chip, [site='BH'] .btn.emplify, [site='BH'] .btn.emplifynew, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light, :host([site='BH']) .btn.chip, :host([site='BH']) .btn.emplify, :host([site='BH']) .btn.emplifynew {
  font-family:var(--bh-ff-body);
}

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, [site='BH'] .btn.chip, [site='BH'] .btn.emplify, [site='BH'] .btn.emplifynew, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light, :host([site='BH']) .btn.chip, :host([site='BH']) .btn.emplify, :host([site='BH']) .btn.emplifynew {
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
}

[site='BH'] .btn.primary.xl, [site='BH'] .btn.secondary.xl, [site='BH'] .btn.tertiary.xl, [site='BH'] .btn.quaternary.xl, [site='BH'] .btn.cta-dark.xl, [site='BH'] .btn.cta-light.xl, [site='BH'] .btn.chip.xl, [site='BH'] .btn.emplify.xl, [site='BH'] .btn.emplifynew.xl, :host([site='BH']) .btn.primary.xl, :host([site='BH']) .btn.secondary.xl, :host([site='BH']) .btn.tertiary.xl, :host([site='BH']) .btn.quaternary.xl, :host([site='BH']) .btn.cta-dark.xl, :host([site='BH']) .btn.cta-light.xl, :host([site='BH']) .btn.chip.xl, :host([site='BH']) .btn.emplify.xl, :host([site='BH']) .btn.emplifynew.xl {
  font-weight:var(--fw-light);
}

[site='BH'] .btn.primary.xl, [site='BH'] .btn.secondary.xl, [site='BH'] .btn.tertiary.xl, [site='BH'] .btn.quaternary.xl, [site='BH'] .btn.cta-dark.xl, [site='BH'] .btn.cta-light.xl, [site='BH'] .btn.chip.xl, [site='BH'] .btn.emplify.xl, [site='BH'] .btn.emplifynew.xl, :host([site='BH']) .btn.primary.xl, :host([site='BH']) .btn.secondary.xl, :host([site='BH']) .btn.tertiary.xl, :host([site='BH']) .btn.quaternary.xl, :host([site='BH']) .btn.cta-dark.xl, :host([site='BH']) .btn.cta-light.xl, :host([site='BH']) .btn.chip.xl, :host([site='BH']) .btn.emplify.xl, :host([site='BH']) .btn.emplifynew.xl{
      font-size:clamp(1.5rem, calc(0rem + 3.13vw), 2rem);
      line-height:110%;
      letter-spacing:-0.16px;
    }

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light {
  font-weight:var(--fw-bold);
}

[site='BH'] .btn.primary, :host([site='BH']) .btn.primary {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.primary, :host([site='BH']) .btn.primary {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.primary:hover, [site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:hover, :host([site='BH']) .btn.primary:focus {
  background-color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-style:solid;
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-width:2px;
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.primary:active, :host([site='BH']) .btn.primary:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.primary:active, :host([site='BH']) .btn.primary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.primary[aria-disabled='true'], :host([site='BH']) .btn.primary[aria-disabled='true'] {
  background-color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.primary[aria-disabled='true'], :host([site='BH']) .btn.primary[aria-disabled='true'] {
  color:var(--bh-neutral-white) !important;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-width:2px;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-style:solid;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:hover, [site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:hover, :host([site='BH']) .btn.secondary:focus {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:hover, [site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:hover, :host([site='BH']) .btn.secondary:focus {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-style:solid;
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-width:2px;
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:active, :host([site='BH']) .btn.secondary:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:active, :host([site='BH']) .btn.secondary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  border-color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.tertiary, :host([site='BH']) .btn.tertiary {
  background-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary, :host([site='BH']) .btn.tertiary {
  color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.tertiary:hover, [site='BH'] .btn.tertiary:focus, [site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:hover, :host([site='BH']) .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:active {
  color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.tertiary:hover, :host([site='BH']) .btn.tertiary:hover {
  background-color:var(--bh-brand-primary-lighter);
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-style:solid;
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-width:2px;
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:active {
  background-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.tertiary[aria-disabled='true'], :host([site='BH']) .btn.tertiary[aria-disabled='true'] {
  background-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.tertiary[aria-disabled='true'], :host([site='BH']) .btn.tertiary[aria-disabled='true'] {
  color:var(--bh-neutral-darker) !important;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-width:2px;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-style:solid;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-style:solid;
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-width:2px;
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary:hover, [site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:hover, :host([site='BH']) .btn.quaternary:active {
  border-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.quaternary:hover, [site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:hover, :host([site='BH']) .btn.quaternary:active {
  background-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  border-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.cta-dark, :host([site='BH']) .btn.cta-dark {
  color:var(--bh-brand-primary-default-compatibility);
}

[site='BH'] .btn.cta-dark:hover, [site='BH'] .btn.cta-dark:active, [site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:hover, :host([site='BH']) .btn.cta-dark:active, :host([site='BH']) .btn.cta-dark:focus {
  color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.cta-dark:hover, [site='BH'] .btn.cta-dark:active, [site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:hover, :host([site='BH']) .btn.cta-dark:active, :host([site='BH']) .btn.cta-dark:focus {
  text-decoration-line:underline;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-style:solid;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-width:2px;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.cta-dark[aria-disabled='true'], :host([site='BH']) .btn.cta-dark[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.cta-dark[aria-disabled='true'], :host([site='BH']) .btn.cta-dark[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.cta-light, :host([site='BH']) .btn.cta-light {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.cta-light:hover, [site='BH'] .btn.cta-light:active, [site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:hover, :host([site='BH']) .btn.cta-light:active, :host([site='BH']) .btn.cta-light:focus {
  text-decoration-line:underline;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-style:solid;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-width:2px;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.cta-light[aria-disabled='true'], :host([site='BH']) .btn.cta-light[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.cta-light[aria-disabled='true'], :host([site='BH']) .btn.cta-light[aria-disabled='true'] {
  color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  border-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  color:var(--bh-neutral-darker);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  border-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.chip:focus, :host([site='BH']) .btn.chip:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:active, :host([site='BH']) .btn.chip:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:active, :host([site='BH']) .btn.chip:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  border-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  background-color:var(--bh-neutral-lighter) !important;
}

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.emplify, :host([site='BH']) .btn.emplify, [site='GHS'] .btn.emplify, :host([site='GHS']) .btn.emplify {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify, :host([site='BH']) .btn.emplify, [site='GHS'] .btn.emplify, :host([site='GHS']) .btn.emplify {
  background-color:var(--eh-brand-secondary-100);
}

[site='BH'] .btn.emplify:hover, [site='BH'] .btn.emplify:focus, :host([site='BH']) .btn.emplify:hover, :host([site='BH']) .btn.emplify:focus, [site='GHS'] .btn.emplify:hover, [site='GHS'] .btn.emplify:focus, :host([site='GHS']) .btn.emplify:hover, :host([site='GHS']) .btn.emplify:focus {
  background-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify:hover,
    [site='BH'] .btn.emplify:focus,
    :host([site='BH']) .btn.emplify:hover,
    :host([site='BH']) .btn.emplify:focus,
    [site='GHS'] .btn.emplify:hover,
    [site='GHS'] .btn.emplify:focus,
    :host([site='GHS']) .btn.emplify:hover,
    :host([site='GHS']) .btn.emplify:focus{
      color:#fff;
    }

[site='BH'] .btn.emplify:focus, :host([site='BH']) .btn.emplify:focus, [site='GHS'] .btn.emplify:focus, :host([site='GHS']) .btn.emplify:focus {
  outline-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify .right:has(> .extra-icon), :host([site='BH']) .btn.emplify .right:has(> .extra-icon), [site='GHS'] .btn.emplify .right:has(> .extra-icon), :host([site='GHS']) .btn.emplify .right:has(> .extra-icon) {
  padding-left:0px;
}

[site='BH'] .btn.emplify .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplify .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplify .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplify .right:has(> .extra-icon) .extra-icon {
  margin-left:0.25rem;
}

@media (min-width: 1024px){
      [site='BH'] .btn.emplify.small, :host([site='BH']) .btn.emplify.small, [site='GHS'] .btn.emplify.small, :host([site='GHS']) .btn.emplify.small {
    margin-top:0.375rem;
    margin-bottom:0.375rem;
  }
    }

[site='BH'] .btn.emplifynew .right:has(> .extra-icon), [site='BH'] .btn.bellinmychart .right:has(> .extra-icon), [site='BH'] .btn.emplifymychart .right:has(> .extra-icon), :host([site='BH']) .btn.emplifynew .right:has(> .extra-icon), :host([site='BH']) .btn.bellinmychart .right:has(> .extra-icon), :host([site='BH']) .btn.emplifymychart .right:has(> .extra-icon), [site='GHS'] .btn.emplifynew .right:has(> .extra-icon), [site='GHS'] .btn.bellinmychart .right:has(> .extra-icon), [site='GHS'] .btn.emplifymychart .right:has(> .extra-icon), :host([site='GHS']) .btn.emplifynew .right:has(> .extra-icon), :host([site='GHS']) .btn.bellinmychart .right:has(> .extra-icon), :host([site='GHS']) .btn.emplifymychart .right:has(> .extra-icon) {
  padding-left:0px;
}

[site='BH'] .btn.emplifynew .right:has(> .extra-icon) .extra-icon, [site='BH'] .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, [site='BH'] .btn.emplifymychart .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplifynew .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplifymychart .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplifynew .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplifymychart .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplifynew .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplifymychart .right:has(> .extra-icon) .extra-icon {
  margin-left:0.25rem;
}

@media (min-width: 1024px){
      [site='BH'] .btn.emplifynew.small, [site='BH'] .btn.bellinmychart.small, [site='BH'] .btn.emplifymychart.small, :host([site='BH']) .btn.emplifynew.small, :host([site='BH']) .btn.bellinmychart.small, :host([site='BH']) .btn.emplifymychart.small, [site='GHS'] .btn.emplifynew.small, [site='GHS'] .btn.bellinmychart.small, [site='GHS'] .btn.emplifymychart.small, :host([site='GHS']) .btn.emplifynew.small, :host([site='GHS']) .btn.bellinmychart.small, :host([site='GHS']) .btn.emplifymychart.small {
    margin-top:0.375rem;
    margin-bottom:0.375rem;
  }
    }

[site='BH'] .btn.emplifynew, :host([site='BH']) .btn.emplifynew, [site='GHS'] .btn.emplifynew, :host([site='GHS']) .btn.emplifynew {
  background-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplifynew:hover, [site='BH'] .btn.emplifynew:focus, :host([site='BH']) .btn.emplifynew:hover, :host([site='BH']) .btn.emplifynew:focus, [site='GHS'] .btn.emplifynew:hover, [site='GHS'] .btn.emplifynew:focus, :host([site='GHS']) .btn.emplifynew:hover, :host([site='GHS']) .btn.emplifynew:focus {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplifynew:hover,
    [site='BH'] .btn.emplifynew:focus,
    :host([site='BH']) .btn.emplifynew:hover,
    :host([site='BH']) .btn.emplifynew:focus,
    [site='GHS'] .btn.emplifynew:hover,
    [site='GHS'] .btn.emplifynew:focus,
    :host([site='GHS']) .btn.emplifynew:hover,
    :host([site='GHS']) .btn.emplifynew:focus{
      background-color:#fff;
    }

[site='BH'] .btn.bellinmychart, :host([site='BH']) .btn.bellinmychart, [site='GHS'] .btn.bellinmychart, :host([site='GHS']) .btn.bellinmychart{
    background-color:transparent;
    color:#fff;
  }

[site='BH'] .btn.bellinmychart, :host([site='BH']) .btn.bellinmychart, [site='GHS'] .btn.bellinmychart, :host([site='GHS']) .btn.bellinmychart {
  font-weight:var(--fw-bold);
}

[site='BH'] .btn.bellinmychart, :host([site='BH']) .btn.bellinmychart, [site='GHS'] .btn.bellinmychart, :host([site='GHS']) .btn.bellinmychart{
    font-size:var(--fs-xs);
  }

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart{
    background-color:transparent;
  }

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart {
  padding:0px;
}

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart{
    font-size:var(--fs-sm);
  }

:host {
  font-family:var(--bh-ff-body);
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
}

a:not(.btn), p a:not(.btn), li a:not(.btn) {
  color:var(--bh-brand-primary-default);
  text-decoration-thickness:1px;
}

a:not(.btn):hover, a:not(.btn):focus, p a:not(.btn):hover, p a:not(.btn):focus, li a:not(.btn):hover, li a:not(.btn):focus {
  text-decoration-line:underline;
}

a:not(.btn):hover, a:not(.btn):focus, p a:not(.btn):hover, p a:not(.btn):focus, li a:not(.btn):hover, li a:not(.btn):focus {
  text-decoration-thickness:2px;
}

ul:not(.list-x-mark, .list-check-mark) > li:before {
  background-color:var(--bh-brand-primary-default);
}

ul.list-check-mark > li {
  padding-left:1.75rem;
}

ul.list-check-mark > li:before {
  top:0.375rem;
}

ul.list-check-mark > li:before{
      background-image:url("data:image/svg+xml,%3Csvg width='18' height='14' viewBox='0 0 18 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.15 13.8313L0 7.68135L1.9 5.78135L6.15 10.0563L15.3 0.881348L17.2 2.78135L6.15 13.8313Z' fill='%23007CC2'/%3E%3C/svg%3E%0A");
    }

ul.list-x-mark > li {
  padding-left:1.75rem;
}

ul.list-x-mark > li:before {
  top:0.375rem;
}

ul.list-x-mark > li:before{
      background-image:url("data:image/svg+xml,%3Csvg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.6672 1.22549C14.2235 0.781803 13.5068 0.781803 13.0631 1.22549L7.5 6.77725L1.93686 1.21411C1.49317 0.770426 0.776451 0.770426 0.332765 1.21411C-0.110922 1.6578 -0.110922 2.37452 0.332765 2.81821L5.89591 8.38135L0.332765 13.9445C-0.110922 14.3882 -0.110922 15.1049 0.332765 15.5486C0.776451 15.9923 1.49317 15.9923 1.93686 15.5486L7.5 9.98544L13.0631 15.5486C13.5068 15.9923 14.2235 15.9923 14.6672 15.5486C15.1109 15.1049 15.1109 14.3882 14.6672 13.9445L9.1041 8.38135L14.6672 2.81821C15.0995 2.3859 15.0995 1.6578 14.6672 1.22549Z' fill='%23007CC2'/%3E%3C/svg%3E%0A");
    }

ol > li::before {
  color:var(--bh-brand-primary-default);
}

hr {
  border-bottom-width:1px;
  border-color:var(--bh-neutral-default);
}

blockquote {
  margin-left:0px;
  margin-right:0px;
  border-width:0px;
  border-top-width:2px;
  border-bottom-width:2px;
  border-color:var(--bh-brand-primary-default);
  padding-left:1rem;
  padding-right:1rem;
  padding-top:3rem;
  padding-bottom:3rem;
  font-family:var(--bh-ff-display);
}

@media (min-width: 1024px) {

  blockquote {
    padding-top:4rem;
    padding-bottom:4rem;
  }
}

blockquote::before {
  margin-bottom:1.5rem;
}

blockquote::before {
  height:2rem;
}

blockquote::before {
  width:2.5rem;
}

@media (min-width: 1024px) {

  blockquote::before {
    height:2.5rem;
  }
}

@media (min-width: 1024px) {

  blockquote::before {
    width:3.5rem;
  }
}

blockquote::before{

    background-image:url("data:image/svg+xml,%3Csvg width='53' height='42' viewBox='0 0 53 42' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.954 0 15.39 19.764h6.48v21.87H0V19.44L5.832 0h13.122ZM49.41 0l-3.564 19.764h6.48v21.87h-21.87V19.44L36.288 0H49.41Z' fill='%23007CC2'/%3E%3C/svg%3E%0A");
    background-size:100%;
  }

blockquote .author {
  margin:0px;
}

blockquote .author {
  font-family:var(--bh-ff-body);
}

blockquote .author {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

@media (min-width: 1024px) {

  blockquote .author {
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
  }
}

blockquote .author::before {
  --tw-content:none;
  content:none;
  content:var(--tw-content);
}

.neutral-black {
  color:var(--bh-neutral-black);
}

.table-wrapper::-webkit-scrollbar-track {
  background-color:var(--bh-neutral-light);
}

.table-wrapper::-webkit-scrollbar-thumb {
  background-color:var(--bh-brand-primary-default);
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background-color:var(--bh-brand-primary-light);
}

.btn.secondary::after, .btn.cta-dark::after{
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='%23007CC2'%3E%3C/path%3E%3C/svg%3E");
    }

.btn.secondary:hover::after, .btn.secondary:focus::after{
        background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='white'%3E%3C/path%3E%3C/svg%3E");
      }

.btn.cta-dark:hover::after, .btn.cta-dark:focus::after{
        background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='%23004E7A'%3E%3C/path%3E%3C/svg%3E");
      }

ghs-image[site='GHS'] img{
  box-shadow:var(--brand-shadow);
}

:host {
  display:block;
  overflow-wrap:break-word;
}

@media (min-width: 768px) {

  :host {
    overflow-wrap:normal;
    word-break:normal;
  }
}

:host([max-width]) {
  max-width:var(--bh-max-w-text);
}

p, h1, h2, h3, h4, ul, ol, ghs-image, figure, table {
  margin-bottom:1rem;
}

@media (min-width: 1280px) {

  p, h1, h2, h3, h4, ul, ol, ghs-image, figure, table {
    margin-bottom:2rem;
  }
}

h1, h2, h3, h4 {
  font-weight:var(--fw-bold);
}

h5, h6 {
  margin-bottom:1rem;
  font-weight:var(--fw-bold);
}

a:not(.btn), p a:not(.btn), li a:not(.btn) {
  text-decoration-line:underline;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:500ms;
}

a:not(.btn):hover, a:not(.btn):focus, p a:not(.btn):hover, p a:not(.btn):focus, li a:not(.btn):hover, li a:not(.btn):focus {
  text-decoration-line:none;
}

ol, ul {
  list-style-type:none;
  counter-reset:ol-counter;
}

ul ul, ol ol, ul ol, ol ul {
  margin-top:0.5rem;
}

@media (min-width: 1024px) {

  ul ul, ol ol, ul ol, ol ul {
    margin-top:1rem;
  }
}

ul > li {
  padding-left:1.25rem;
}

ul > li, ol > li {
  position:relative;
  margin-bottom:.35rem;
}

@media (min-width: 1024px) {

  ul > li, ol > li {
    margin-bottom:0.5rem;
  }
}

ul:not(.list-x-mark, .list-check-mark) > li:before {
  position:absolute;
  top:0.5rem;
  left:0px;
  margin-right:0.75rem;
  display:block;
  height:0.5rem;
  width:0.5rem;
  border-radius:9999px;
  content:'';
}

li > ul, li > ol {
  margin-bottom:0px;
}

ul.list-check-mark > li {
  padding-left:2.25rem;
}

ul.list-check-mark > li:before {
  position:absolute;
}

ul.list-check-mark > li:before {
  top:0.25rem;
}

ul.list-check-mark > li:before {
  left:0px;
}

ul.list-check-mark > li:before {
  display:block;
}

ul.list-check-mark > li:before {
  height:1.5rem;
}

ul.list-check-mark > li:before {
  width:1.5rem;
}

ul.list-check-mark > li:before {
  background-repeat:no-repeat;
}

ul.list-check-mark > li:before{

      content:'';
      background-image:url("data:image/svg+xml,%3Csvg width='25' height='20' viewBox='0 0 25 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.3335 0.192161L7.95115 14.5745L2.66655 9.28991C2.41034 9.0337 1.9949 9.0337 1.73863 9.28991L0.192161 10.8364C-0.0640536 11.0926 -0.0640536 11.508 0.192161 11.7643L7.48717 19.0593C7.74338 19.3155 8.15882 19.3155 8.41508 19.0593L24.8078 2.66655C25.0641 2.41034 25.0641 1.9949 24.8078 1.73863L23.2614 0.192161C23.0052 -0.0640537 22.5897 -0.0640537 22.3335 0.192161Z' fill='%23000'/%3E%3C/svg%3E%0A");
    }

ul.list-x-mark > li {
  padding-left:1.75rem;
}

ul.list-x-mark > li:before {
  position:absolute;
}

ul.list-x-mark > li:before {
  top:0.25rem;
}

ul.list-x-mark > li:before {
  left:0px;
}

ul.list-x-mark > li:before {
  display:block;
}

ul.list-x-mark > li:before {
  height:1.5rem;
}

ul.list-x-mark > li:before {
  width:1.5rem;
}

ul.list-x-mark > li:before {
  background-repeat:no-repeat;
}

ul.list-x-mark > li:before{

      content:'';
      background-image:url("data:image/svg+xml,%3Csvg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.6672 1.22549C14.2235 0.781803 13.5068 0.781803 13.0631 1.22549L7.5 6.77725L1.93686 1.21411C1.49317 0.770426 0.776451 0.770426 0.332765 1.21411C-0.110922 1.6578 -0.110922 2.37452 0.332765 2.81821L5.89591 8.38135L0.332765 13.9445C-0.110922 14.3882 -0.110922 15.1049 0.332765 15.5486C0.776451 15.9923 1.49317 15.9923 1.93686 15.5486L7.5 9.98544L13.0631 15.5486C13.5068 15.9923 14.2235 15.9923 14.6672 15.5486C15.1109 15.1049 15.1109 14.3882 14.6672 13.9445L9.1041 8.38135L14.6672 2.81821C15.0995 2.3859 15.0995 1.6578 14.6672 1.22549Z' fill='%23000'/%3E%3C/svg%3E%0A");
    }

ol > li {
  padding-left:2.25rem;
  counter-increment:ol-counter;
}

ol > li::before {
  position:absolute;
}

ol > li::before {
  left:0px;
}

ol > li::before {
  display:block;
}

ol > li::before {
  font-weight:var(--fw-bold);
}

ol > li::before{
    content:'0' counter(ol-counter);
  }

ol > li:nth-child(n + 10)::before{
    content:counter(ol-counter);
  }

hr {
  margin-bottom:1.75rem;
  display:block;
  width:100%;
  border-width:0px;
  border-bottom-width:1px;
  border-style:solid;
}

blockquote {
  position:relative;
  margin-left:0px;
  margin-right:0px;
  margin-bottom:1rem;
  margin-top:2.25rem;
  border-style:solid;
  font-size:var(--fs-2xl);
  line-height:var(--lh-2xl);
}

@media (min-width: 1024px) {

  blockquote {
    margin-bottom:2rem;
  }

  blockquote {
    font-size:var(--fs-3xl);
    line-height:var(--lh-3xl);
  }
}

blockquote::before {
  position:static;
}

blockquote::before {
  display:block;
}

blockquote::before {
  background-repeat:no-repeat;
}

blockquote::before{
    content:'';
  }

blockquote .author {
  margin-bottom:0.5rem;
}

blockquote .author {
  display:inline-flex;
}

blockquote .author {
  align-items:center;
}

blockquote .author {
  gap:0.5rem;
}

blockquote .author {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

blockquote .author::before {
  display:inline-block;
}

blockquote .author::before {
  height:0.25rem;
}

blockquote .author::before {
  width:1.25rem;
}

blockquote .author::before {
  border-width:0px;
}

blockquote .author::before {
  border-bottom-width:1px;
}

blockquote .author::before {
  border-style:solid;
}

blockquote .author::before{
      content:'';
    }

table, th, td, thead {
  border-collapse:collapse;
}

.table-wrapper {
  overflow-x:auto;
}

.table-wrapper::-webkit-scrollbar {
  width:0.5rem;
}

.table-wrapper::-webkit-scrollbar-track {
  border-radius:0.5rem;
}

.table-wrapper::-webkit-scrollbar-track {
  border-style:none;
}

.table-wrapper::-webkit-scrollbar-thumb {
  border-radius:0.5rem;
}

table thead {
  border-bottom-width:2px;
}

table thead {
  border-style:solid;
}

table thead {
  border-color:var(--bh-neutral-black);
}

table tbody tr {
  border-bottom-width:1px;
}

table tbody tr {
  border-style:solid;
}

table tbody tr {
  border-color:var(--bh-neutral-default);
}

table tbody [scope='row'] {
  border-right-width:2px;
}

table tbody [scope='row'] {
  border-style:solid;
}

table tbody [scope='row'] {
  border-color:var(--bh-neutral-black);
}

ul.columns-2, ul.columns-3 {
  gap:2rem;

  columns:1;
}

@media (min-width: 768px){
  ul.columns-2{
    columns:2;
  }

  ul.columns-3{
    columns:3;
  }
    ul.columns-2 li, ul.columns-3 li {
    text-align:left;
  }
}

.text-align-left{
  text-align:left;
}

.text-align-right{
  text-align:right;
}

.text-align-center{
  text-align:center;
}

.text-align-justify{
  text-align:justify;
}

.align-left:not(.ck-widget *), .align-right:not(.ck-widget *), .align-center:not(.ck-widget *) {
  clear:both;
  max-width:100%;
}

@media (min-width: 1024px) {

  .align-left:not(.ck-widget *), .align-right:not(.ck-widget *), .align-center:not(.ck-widget *) {
    max-width:50%;
  }
}

.align-left {
  float:left;
}

@media (min-width: 1024px) {

  .align-left {
    padding-right:1rem;
  }
}

.align-right {
  float:right;
}

@media (min-width: 1024px) {

  .align-right {
    padding-left:1rem;
  }
}

.align-center {
  display:flex;
  align-items:center;
  justify-content:center;
}

.btn {
  margin-bottom:0.75rem;
  display:inline-flex;
  align-items:center;
}

.btn::after {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

.btn::after {
  transition-duration:300ms;
}

.btn:hover::after,
  .btn:focus::after{
    transform:translateX(40%);
  }

.btn.primary::after, .btn.secondary::after, .btn.emplify::after, .btn.cta-dark::after {
  margin-left:1rem;
}

.btn.primary::after, .btn.secondary::after, .btn.emplify::after, .btn.cta-dark::after {
  display:block;
}

.btn.primary::after, .btn.secondary::after, .btn.emplify::after, .btn.cta-dark::after {
  height:1rem;
}

.btn.primary::after, .btn.secondary::after, .btn.emplify::after, .btn.cta-dark::after {
  width:1rem;
}

.btn.primary::after, .btn.secondary::after, .btn.emplify::after, .btn.cta-dark::after {
  background-position:center;
}

.btn.primary::after, .btn.secondary::after, .btn.emplify::after, .btn.cta-dark::after {
  background-repeat:no-repeat;
}

.btn.primary::after, .btn.secondary::after, .btn.emplify::after, .btn.cta-dark::after{
      content:'';
    }

.btn.emplify::after{
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='currentColor'%3E%3C/path%3E%3C/svg%3E");
    }

.btn.emplify:hover::after, .btn.primary::after{
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='white'%3E%3C/path%3E%3C/svg%3E");
    }

figure ghs-image {
  margin-bottom:1.25rem;
}

figure figcaption {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
  font-style:italic;
  color:var(--neutral-gray);
}

:host([variant='dark']), :host([variant='hero']) {
  color:var(--neutral-white);
}

:host([variant='dark']) p a:not(.btn), :host([variant='dark']) li a:not(.btn), :host([variant='hero']) p a:not(.btn), :host([variant='hero']) li a:not(.btn) {
  color:var(--neutral-white);
}

:host([variant='dark']) p a:not(.btn), :host([variant='dark']) li a:not(.btn), :host([variant='hero']) p a:not(.btn), :host([variant='hero']) li a:not(.btn) {
  text-decoration-line:underline;
}

:host([variant='dark']) p a:not(.btn), :host([variant='dark']) li a:not(.btn), :host([variant='hero']) p a:not(.btn), :host([variant='hero']) li a:not(.btn) {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

:host([variant='dark']) p a:not(.btn), :host([variant='dark']) li a:not(.btn), :host([variant='hero']) p a:not(.btn), :host([variant='hero']) li a:not(.btn) {
  transition-duration:500ms;
}

:host([variant='dark']) p a:not(.btn):hover, :host([variant='dark']) p a:not(.btn):focus, :host([variant='dark']) li a:not(.btn):hover, :host([variant='dark']) li a:not(.btn):focus, :host([variant='hero']) p a:not(.btn):hover, :host([variant='hero']) p a:not(.btn):focus, :host([variant='hero']) li a:not(.btn):hover, :host([variant='hero']) li a:not(.btn):focus {
  background-color:var(--neutral-white);
}

:host([variant='dark']) p a:not(.btn):hover, :host([variant='dark']) p a:not(.btn):focus, :host([variant='dark']) li a:not(.btn):hover, :host([variant='dark']) li a:not(.btn):focus, :host([variant='hero']) p a:not(.btn):hover, :host([variant='hero']) p a:not(.btn):focus, :host([variant='hero']) li a:not(.btn):hover, :host([variant='hero']) li a:not(.btn):focus {
  color:var(--primary-blue);
}

:host([variant='dark']) p a:not(.btn):hover, :host([variant='dark']) p a:not(.btn):focus, :host([variant='dark']) li a:not(.btn):hover, :host([variant='dark']) li a:not(.btn):focus, :host([variant='hero']) p a:not(.btn):hover, :host([variant='hero']) p a:not(.btn):focus, :host([variant='hero']) li a:not(.btn):hover, :host([variant='hero']) li a:not(.btn):focus {
  text-decoration-line:none;
}

:host([variant='dark']) .neutral-black, :host([variant='dark']) .dark-blue, :host([variant='hero']) .neutral-black, :host([variant='hero']) .dark-blue {
  color:var(--neutral-white);
}

:host([variant='dark']) ul:not(.list-x-mark, .list-check-mark) > li:before, :host([variant='hero']) ul:not(.list-x-mark, .list-check-mark) > li:before {
  background-color:var(--neutral-white);
}

:host([variant='dark']) ul.list-check-mark > li:before, :host([variant='hero']) ul.list-check-mark > li:before{
    background-image:url("data:image/svg+xml,%3Csvg width='25' height='20' viewBox='0 0 25 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.3335 0.192161L7.95115 14.5745L2.66655 9.28991C2.41034 9.0337 1.9949 9.0337 1.73863 9.28991L0.192161 10.8364C-0.0640536 11.0926 -0.0640536 11.508 0.192161 11.7643L7.48717 19.0593C7.74338 19.3155 8.15882 19.3155 8.41508 19.0593L24.8078 2.66655C25.0641 2.41034 25.0641 1.9949 24.8078 1.73863L23.2614 0.192161C23.0052 -0.0640537 22.5897 -0.0640537 22.3335 0.192161Z' fill='%23FFF'/%3E%3C/svg%3E%0A");
  }

:host([variant='dark']) ol > li::before, :host([variant='hero']) ol > li::before {
  color:var(--neutral-white);
}

:host([variant='dark']) .btn.primary, :host([variant='hero']) .btn.primary {
  background-color:var(--neutral-white);
}

:host([variant='dark']) .btn.primary, :host([variant='hero']) .btn.primary {
  color:var(--primary-blue);
}

:host([variant='dark']) .btn.secondary, :host([variant='hero']) .btn.secondary {
  background-color:var(--neutral-white);
}

:host([variant='dark']) .btn.secondary, :host([variant='hero']) .btn.secondary {
  color:var(--primary-green);
}

:host([variant='dark']) .btn.primary::after, :host([variant='hero']) .btn.primary::after{
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='%230a2e4c'%3E%3C/path%3E%3C/svg%3E");
  }

:host([variant='dark']) .btn.secondary::after, :host([variant='hero']) .btn.secondary::after{
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 8 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Cpath d='M.35.747L.116.981a.397.397 0 000 .56l6.46 6.46-6.46 6.46a.397.397 0 000 .56l.234.233a.397.397 0 00.56 0l6.974-6.973a.397.397 0 000-.56L.91.746a.396.396 0 00-.56 0z' fill='%2300665e'%3E%3C/path%3E%3C/svg%3E");
  }

:host([variant='dark']) .btn.cta-dark, :host([variant='dark']) .btn.cta-dark:hover, :host([variant='hero']) .btn.cta-dark, :host([variant='hero']) .btn.cta-dark:hover {
  color:var(--neutral-white);
}

:host([variant='dark']) .btn.cta-dark::after, :host([variant='dark']) .btn.cta-dark:hover::after, :host([variant='hero']) .btn.cta-dark::after, :host([variant='hero']) .btn.cta-dark:hover::after{
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='false'%3E%3Ccircle cx='10' cy='10' r='10' fill='white'%3E%3C/circle%3E%3Cpath d='M8.464 6.069l-.139.138a.235.235 0 000 .333l3.83 3.83-3.83 3.83a.235.235 0 000 .333l.139.138c.092.092.24.092.332 0l4.135-4.135a.235.235 0 000-.332L8.796 6.069a.235.235 0 00-.332 0z' fill='%231561a0'%3E%3C/path%3E%3C/svg%3E");
    }

:host([size='small']) {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

:host([size='small']) p, :host([size='small']) h1, :host([size='small']) h2, :host([size='small']) h3, :host([size='small']) h4 {
  margin-bottom:0.5rem;
}

@media (min-width: 1280px) {

  :host([size='small']) p, :host([size='small']) h1, :host([size='small']) h2, :host([size='small']) h3, :host([size='small']) h4 {
    margin-bottom:1rem;
  }
}

:host([size='small']) p, :host([size='small']) ul > li, :host([size='small']) ol > li {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

:host([size='small']) h5, :host([size='small']) h6 {
  margin-bottom:0.5rem;
}

:host([size='small']) h1 {
  font-size:var(--fs-h3-small);
  line-height:var(--lh-h3-small);
}

@media (min-width: 768px) {

  :host([size='small']) h1 {
    font-size:var(--fs-h3-medium);
    line-height:var(--lh-h3-medium);
  }
}

@media (min-width: 1024px) {

  :host([size='small']) h1 {
    font-size:var(--fs-h3);
    line-height:var(--lh-h3);
  }
}

:host([size='small']) h2 {
  font-size:var(--fs-h4-small);
  line-height:var(--lh-h4-small);
}

@media (min-width: 768px) {

  :host([size='small']) h2 {
    font-size:var(--fs-h4-medium);
    line-height:var(--lh-h4-medium);
  }
}

@media (min-width: 1024px) {

  :host([size='small']) h2 {
    font-size:var(--fs-h4);
    line-height:var(--lh-h4);
  }
}

:host([size='small']) h3 {
  font-size:var(--fs-h5-small);
  line-height:var(--lh-h5-small);
}

@media (min-width: 768px) {

  :host([size='small']) h3 {
    font-size:var(--fs-h5-medium);
    line-height:var(--lh-h5-medium);
  }
}

@media (min-width: 1024px) {

  :host([size='small']) h3 {
    font-size:var(--fs-h5);
    line-height:var(--lh-h5);
  }
}

:host([size='small']) h4 {
  font-size:var(--fs-h6-small);
  line-height:var(--lh-h6-small);
}

@media (min-width: 768px) {

  :host([size='small']) h4 {
    font-size:var(--fs-h6-medium);
    line-height:var(--lh-h6-medium);
  }
}

@media (min-width: 1024px) {

  :host([size='small']) h4 {
    font-size:var(--fs-h6);
    line-height:var(--lh-h6);
  }
}

:host([size='small']) h5 {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

:host([size='small']) h6 {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

:host([size='small']) blockquote {
  margin-left:0px;
  margin-right:0px;
}

:host([size='small']) blockquote {
  margin-bottom:1rem;
}

:host([size='small']) blockquote {
  margin-top:2.25rem;
}

:host([size='small']) blockquote {
  padding-left:1.25rem;
  padding-right:1.25rem;
}

:host([size='small']) blockquote {
  padding-top:2.5rem;
}

:host([size='small']) blockquote {
  padding-bottom:1.25rem;
}

:host([size='small']) blockquote {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

@media (min-width: 1024px) {

  :host([size='small']) blockquote {
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
  }
}

:host([size='small']) blockquote .author {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

:host([size='small']) blockquote::before {
  top:-2rem;
}

:host([size='small']) blockquote::before {
  left:1.5rem;
}

:host([size='small']) blockquote::before {
  padding-left:1rem;
  padding-right:1rem;
}

:host([size='small']) blockquote::before {
  display:block;
}

:host([size='small']) blockquote::before {
  height:4rem;
}

:host([size='small']) blockquote::before {
  width:7rem;
}

:host([size='small']) blockquote::before{

      background-size:60%;
    }

:host([size='base']) {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

:host([size='base']) ul > li, :host([size='base']) ol > li {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}
`;